/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

/* eslint no-underscore-dangle:0*/

'use strict';

var Emitter = require('cjs-emitter'),
    app = require('mag-app'),
    exitTS = require('./exit.timeshift'),
    tools = require('./tools'),
    player = new Emitter(),
    intents = {},
    playerManager = app.playerManager,
    players = app.playerManager.list,
    primaryPlayer = app.playerManager.list[0],
    primaryIndex = 0,
    pipIntent,
    osdPipIntent,

    PROXY = (top.system && top.system.queryParameters && top.system.queryParameters.proxy) ? top.system.queryParameters.proxy : '',
    SINGLE = app.playerManager.list.length === 1 || tools.useSingleModeByDeviceModel();


player.STATE_IDLE = 0;
player.STATE_OPENING = 1;
player.STATE_PLAYING = 2;
player.STATE_PAUSE = 3;


if ( app.query.multicastProxy ) {
    PROXY = app.query.multicastProxy;
}

function onTracksInfo () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('media:info', {
            audioTracks: primaryPlayer.audioTracks,
            subtitlesTracks: primaryPlayer.subtitlesTracks
        });
    }
}

function onContentInfo () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('content:info', {
            videoInfo: primaryPlayer.videoInfo
        });
    }
}

function onPlayEnd () {

    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('end', {});
    }
}

function onPlayStart () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('start', {});
    }
}

function onPlayError () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('error', {code: 5});
    }
}

function onDualMono () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('content:dualMono', {});
    }
}

function onTracksUpdate () {
    if ( app.lastPrimaryIntent ) {
        app.lastPrimaryIntent.emit('tracks:update', {tracks: primaryPlayer.subtitlesTracks});
    }
}

function setHandlers ( playerLink ) {
    playerLink.onPlayStart = onPlayStart;
    playerLink.onPlayEnd = onPlayEnd;
    playerLink.onPlayError = onPlayError;
    playerLink.onTracksInfo = onTracksInfo;
    playerLink.onTracksUpdate = onTracksUpdate;
    playerLink.onContentInfo = onContentInfo;
    playerLink.onDualMono = onDualMono;
}

function clearHandlers ( playerLink ) {
    /* eslint no-empty-function:0*/
    playerLink.onPlayStart = function () {};
    playerLink.onPlayEnd = function () {};
    playerLink.onPlayError = function () {};
    playerLink.onTracksInfo = function () {};
    playerLink.onContentInfo = function () {};
    playerLink.onDualMono = function () {};
    playerLink.onTracksUpdate = function () {};
}

/**
 * Set active audio source
 * Small wrapper around stbAudioManager
 *
 * @param {Object} source - source of audio
 */
function setAudioSource ( source ) {
    app.log('set audio to player #' + source.id);

    // if our current audio output source is not that we set, then clear and set
    if ( app.audioManager.list[0].list[0] !== source ) {
        // clear all previous audio outputs
        app.audioManager.list[0].clear();
        app.audioManager.list[0].add(source);
    }
}

player.intent = function ( intent, callback, redefine ) {
    if ( intent  && intent.action &&  intents[intent.action] ) {
        intents[intent.action](intent, callback, redefine);
    }
};

// do some good magic
setHandlers(primaryPlayer);
setAudioSource(primaryPlayer);

player.setAudioSource = setAudioSource;

player.primary = {
    stop: function () {
        // some hack, need to fix
        if ( !primaryPlayer ) {
            return;
        }
        exitTS();
        primaryPlayer.stop();
    },
    pause: function () {
        primaryPlayer.pause();
    },
    resume: function () {
        primaryPlayer.resume();
    },
    rewind: function ( time ) {
        primaryPlayer.position += +time;
    },
    setAudioPid: function ( /*pid*/ ) {
        // set audio pid
        // TODO: impliment method
    },
    play: function ( config ) {
        primaryPlayer.play({
            uri: config.uri,
            solution: config.solution || '',
            position: config.position || 0
        });
    },
    loadExternalSubtitles: function ( url ) {
        primaryPlayer.loadExternalSubtitles(url);
        player.primary.enableSubtitles = true;
    }
};
player.reset = function () {
    primaryPlayer = playerManager.list[0];
    primaryIndex = 0;
    app.lastPrimaryIntent = null;
    app.pipPlayer = null;
    setHandlers(primaryPlayer);
    setAudioSource(primaryPlayer);
    primaryPlayer.fullscreen = true;
};

Object.defineProperties(player.primary, {
    duration: {
        get: function () {
            return primaryPlayer.duration;
        },
        set: function ( val ) {
            primaryPlayer.duration = val;
        }
    },
    position: {
        get: function () {
            return primaryPlayer.position;
        },
        set: function ( val ) {
            primaryPlayer.position = val;
        }
    },
    state: {
        get: function () {
            return primaryPlayer.state;
        }
    },
    aspect: {
        get: function () {
            return primaryPlayer.aspectConversion;
        },
        set: function ( val ) {
            primaryPlayer.aspectConversion = val;
        }
    },
    audioPID: {
        get: function () {
            return primaryPlayer.audioPID;
        },
        set: function ( val ) {
            primaryPlayer.audioPID = val;
        }
    },
    audioTracks: {
        get: function () {
            return primaryPlayer.audioTracks;
        }
    },
    subtitlesPID: {
        get: function () {
            return primaryPlayer.subtitlesPID;
        },
        set: function ( val ) {
            primaryPlayer.subtitlesPID = val;
            primaryPlayer.enableSubtitles = !!val;
        }
    },
    subtitlesTracks: {
        get: function () {

            return primaryPlayer.subtitlesTracks;
        },
        set: function () {
            // primaryPlayer.subtitlesPID = val;
            // primaryPlayer.enableSubtitles = !!val;
        }
    },
    enableSubtitles: {
        get: function () {
            return primaryPlayer.enableSubtitles;
        },
        set: function ( val ) {
            primaryPlayer.enableSubtitles = !!val;
        }
    },
    videoInfo: {
        get: function () {
            return primaryPlayer.videoInfo;
        }
    },
    volume: {
        get: function () {
            return primaryPlayer.volume;
        },
        set: function ( val ) {
            primaryPlayer.volume = +val;
        }
    }
});

Object.defineProperty(player, 'subtitlesEncoding', {
    get: function () {
        return playerManager.list[0].subtitlesEncoding;
    },
    set: function ( value ) {
        playerManager.list.forEach(function ( stbPlayer ) {
            stbPlayer.subtitlesEncoding = value;
        });
    }
});

intents.play = function ( intent, callback, redefine, preventCallback ) { /*eslint no-shadow:0*/
    var result, player,
        metadata = {},
        solution,
        playExtraString;


    if ( intent.context ) {
        player = players[intent.context.playerId];
        result = intent.context;
    } else {
        player = primaryPlayer;
        result = {
            playerId: primaryIndex
        };
    }

    if ( player === primaryPlayer ) {
        app.lastPrimaryIntent = intent;
    }
    if ( !SINGLE ) { // eslint-disable-line
        if ( app.pipPlayer ) {
            setAudioSource(primaryPlayer);
        }
    } else if ( app.pipPlayer ) {
        primaryPlayer = app.pipPlayer;
        player = primaryPlayer;
        primaryPlayer.fullscreen = true;
        app.pipPlayer.surface.moveDown();
        app.pipPlayer = null;
        //osdPipIntent.close();  repaire this
        app.log('emit exit event to pip intent');
        // hack need to be repaire
        osdPipIntent.emit('exit');
    }
    Object.defineProperties(metadata, {
        position: {
            get: function () {
                return primaryPlayer.position;
            }
        },
        duration: {
            get: function () {
                return primaryPlayer.duration;
            }
        },
        audioLang: {
            get: function () {
                var langs = [],
                    index;

                for ( index = 0; index < primaryPlayer.audioTracks.length; index++ ) {
                    if ( primaryPlayer.audioTracks[index].pid === primaryPlayer.audioPID ) {
                        langs = primaryPlayer.audioTracks[index].lang;
                        if ( langs.indexOf('und') > -1 ) {
                            langs = [];
                        }
                    }
                }

                return langs;
            }
        }
    });


    intent.addListener('set:viewport', function ( viewport ) {
        // set viewport
        player.setViewport(tools.getRealViewPort(viewport));
    });

    intent.addListener('set:fullscreen', function () {
        // set viewport
        player.fullscreen = true;
    });

    if ( intent.data.viewport ) {
        player.setViewport(tools.getRealViewPort(intent.data.viewport));
    } else {
        player.fullscreen = true;
    }

    if ( intent.data.aspect !== undefined ) {
        player.aspectConversion = intent.data.aspect;
    }

    if ( core.device && (core.device.model === 'AndroidSTB' || core.device.model === 'emulator_stb') ) {
        // do nothing, because we have bug in old android app versions
        // in android builds we don't have pip, so we never need to move surface
    } else if ( intent.data.displayOnTop ) {
        // move surfaces
        player.surface.moveTop();
    } else {
        player.surface.moveDown();
    }

    // // hack for mag254, bug #18219
    // if ( core.plugins.playback && core.plugins.playback.audioLanguages  && core.plugins.playback.audioLanguages.length ) {
    //     player.audioLanguages = core.plugins.playback.audioLanguages;
    // }

    if ( intent.data.uri ) {
        app.lastPlayUri = intent.data.uri;
        solution = intent.data.solution;

        if ( redefine && redefine.solution ) {
            solution = redefine.solution;
        }
        if ( intent.data.extra && intent.data.extra.length && PLATFORM === 'MAG' ) {
            playExtraString = solution + ' ' + intent.data.uri;

            if ( intent.data.position ) {
                playExtraString += ' position:' + intent.data.position;
            }
            playExtraString += ' ' + intent.data.extra;
            player.play({
                playStr: playExtraString,
                proxy: PROXY
            });
        } else {

            // if ( PROXY ) {
            //     PROXY = tools.parseUriString(PROXY);
            //     // PROXY = PROXY.host + ':' + PROXY.port;
            // }
            player.play({
                uri: intent.data.uri,
                solution: solution,
                position: intent.data.position || 0,
                proxy: PROXY
            });
        }

    }

    app.log('player #' + player.id + ' start play');


    result.metadata = metadata;

    if ( callback && !preventCallback ) {
        window.lastCtx = result;
        callback(false, result);
    }

    return {
        error: false,
        context: result
    };
};


intents.pip = function ( intent ) { /*eslint max-lines-per-function:0*/
    var _player,
        pipDataObject = {},
        idx;

    app.log('pip');

    if ( !SINGLE ) { // eslint-disable-line
        if ( app.pipPlayer ) {

            if ( core.device && (core.device.model === 'MAG256' || core.device.model === 'MAG257') ) {
                // for liege platform set viewport manually, because swap is broken - #20547
                primaryPlayer.setViewport(app.pipPlayer.viewport);
            } else {
                playerManager.swap(app.pipPlayer, primaryPlayer);
            }
            app.pipPlayer.stop();
            _player = app.pipPlayer;
            app.pipPlayer = primaryPlayer;
            primaryPlayer = _player;
            pipIntent = app.lastPrimaryIntent;
            app.lastPrimaryIntent = null;


            //app.pipPlayer = primaryPlayer;
            //primaryPlayer = players[0];
            primaryIndex = 0;
            setAudioSource(app.pipPlayer);
            app.pipPlayer.surface.moveTop();
            clearHandlers(app.pipPlayer);
            setHandlers(primaryPlayer);
        } else {
            idx = primaryPlayer.id;

            app.pipPlayer = primaryPlayer;

            if ( idx ) {
                primaryPlayer = players[0];
                primaryIndex = 0;
            } else {
                primaryPlayer = players[1];
                primaryIndex = 1;
            }

            // console.log('-4');
            // primaryPlayer = players[1];
            // primaryIndex = 1;
            // app.pipPlayer = players[0];

            app.log('pip player is #' + app.pipPlayer.id);
            app.pipPlayer.surface.moveTop();
            clearHandlers(app.pipPlayer);
            setHandlers(primaryPlayer);
            pipIntent = app.lastPrimaryIntent;
            app.lastPrimaryIntent = null;
        }
    } else {
        // only 1 player is available
        app.pipPlayer = primaryPlayer;
        app.pipPlayer.surface.moveTop();
        pipIntent = app.lastPrimaryIntent;
        primaryPlayer = null;
    }


    Object.defineProperties(pipDataObject, {
        position: {
            enumerable: true,
            get: function () {
                if ( app.pipPlayer ) {
                    return app.pipPlayer.position;
                }

                return false;
            }
        },
        duration: {
            enumerable: true,
            get: function () {
                if ( app.pipPlayer ) {
                    return app.pipPlayer.duration;
                }

                return false;
            }
        },
        playerState: {
            enumerable: true,
            get: function () {
                if ( app.pipPlayer ) {
                    return app.pipPlayer.state;
                }

                return false;
            }
        }
    });

    pipDataObject.title = pipIntent.data.title || pipIntent.data.uri || '';

    // console.log('pip player ' + app.pipPlayer.id);

    osdPipIntent = core.intent({
        action: 'pip',
        mime: intent.mime,
        data: pipDataObject,
        events: {
            viewport: function ( coordinates ) {
                console.log('set vp');
                console.log(coordinates);
                app.pipPlayer.setViewport(coordinates);
                console.log('after set vp');
            },
            pause: function () {
                // pause callback
                app.pipPlayer.pause();
            },
            resume: function () {
                // continue playback after stop
                app.pipPlayer.resume();

            },
            maximize: function () {
                // set pip to fullscreen
                debug.log('maximize system level', 'red');
                if ( !SINGLE ) {
                    app.log('maximize pip window');
                    app.log('primary player was #' + primaryPlayer.id);
                    exitTS();
                    primaryPlayer.stop();
                    primaryPlayer = app.pipPlayer;
                    primaryIndex = 0;
                    app.pipPlayer = null;
                    if ( app.lastPrimaryIntent ) {
                        app.lastPrimaryIntent.close();
                    }
                    app.lastPrimaryIntent = pipIntent;
                    primaryPlayer.fullscreen = true;
                    primaryPlayer.surface.moveDown();
                    setAudioSource(primaryPlayer);
                    setHandlers(primaryPlayer);
                    app.log('primary player now is #' + primaryPlayer.id);
                } else {
                    // only 1 player is available
                    primaryPlayer = app.pipPlayer;
                    app.lastPrimaryIntent = pipIntent;
                    primaryPlayer.fullscreen = true;
                    primaryPlayer.surface.moveDown();
                    app.pipPlayer = null;
                }

                if ( intent.events.maximize ) {
                    intent.emit('maximize');
                }
            },
            swap: function () {
                var _player,
                    _intent;

                if ( SINGLE ) {
                    return;
                }

                if (
                    app.lastPrimaryIntent &&
                    app.lastPrimaryIntent.data &&
                    app.lastPrimaryIntent.data.controls &&
                    app.lastPrimaryIntent.data.controls.pip === false
                ) {
                    // disable swap pip for intents that disable pip control button
                    return;
                }

                if ( primaryPlayer.state !== 0 ) {
                    // swap players
                    _player = app.pipPlayer;
                    app.pipPlayer = primaryPlayer;
                    primaryPlayer = _player;
                    playerManager.swap(app.pipPlayer, primaryPlayer);
                    _intent = app.lastPrimaryIntent;
                    app.lastPrimaryIntent = pipIntent;
                    pipIntent = _intent;
                    clearHandlers(app.pipPlayer);
                    setHandlers(primaryPlayer);
                    setAudioSource(primaryPlayer);
                    osdPipIntent.data.mime = pipIntent.mime;
                }

                if ( intent.events.swap ) {
                    intent.emit('swap');
                }
            },
            stop: function () {
                app.log('pip event stop');
                // close btn click
                app.pipPlayer.stop();
                app.log('player #' + app.pipPlayer.id + ' stop');
                // primaryIndex = 0;
                app.pipPlayer.fullscreen = true;
                app.pipPlayer.surface.moveDown();
                app.pipPlayer = null;
                // primaryPlayer = players[0];
                // primaryPlayer.fullscreen = true;
                if ( SINGLE || !primaryPlayer.state ) {
                    primaryPlayer = players[0];
                }

                setAudioSource(primaryPlayer);
                // primaryPlayer.surface.moveDown();
                primaryIndex = primaryPlayer.id;
                setHandlers(primaryPlayer);
                app.pipIntent = null;
            }
        }
    }, function (error, context) {
        debug.log('my callback after pip', 'green');
        debug.log(context, 'green');
        debug.log(error, 'green');

        /*primaryIndex = 1;
        primaryPlayer = players[1];
        app.pipPlayer = players[0];
        app.pipPlayer.surface.moveTop();*/
        //playerManager.setAudioSource(primaryPlayer);
        //pipIntent = ctx;
    });
};


if ( PLATFORM === 'MAG' ) {
    require('../platforms/mag/init')(player);
} else if ( PLATFORM === 'TIZEN' ) {
    require('../platforms/tizen/init')(player);
}


module.exports = player;
